import { render, staticRenderFns } from "./nice-modal.vue?vue&type=template&id=ed34f47c&scoped=true"
import script from "./nice-modal.vue?vue&type=script&lang=js"
export * from "./nice-modal.vue?vue&type=script&lang=js"
import style0 from "./nice-modal.vue?vue&type=style&index=0&id=ed34f47c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed34f47c",
  null
  
)

export default component.exports